<template>
  <VpConfirmModal :modalId="'syncIntegrationConfirmModal'">
    <template v-slot:title>
      <span>{{ $t('integrations.syncRecords') }}</span>
    </template>

    <template v-slot:text1>
      <span>{{ $t('common.notes.areYouSureYouWant') }}
      <strong>“{{$t('integrations.sync')}}”</strong> {{ $t('integrations.selectedRecords') }}</span>
    </template>

    <template v-slot:buttons>
      <VpButton :text="$t('integrations.sync')" :disabled="getLoading" @click="StartSync()" :isLoading="getLoading" />
      <VpButton :text="$t('common.cancel')" :isDanger="true" @click="$bvModal.hide('syncIntegrationConfirmModal')" />
    </template>
  </VpConfirmModal>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
         isLoading: true,
    };
  },
  methods: {
    ...mapActions("integration", ["StartSyncUsers"]),
    StartSync(){
        this.StartSyncUsers({id: this.getIntegId, isFailed: false, redirect: true });
        this.$bvModal.hide("syncIntegrationConfirmModal");
    }
  },
  computed: {
    ...mapGetters("integration", [
      "getLoading",
      "getIntegId",
      "getMigrateStatusText",
      "getMigrateStatusStage",
      "getMigrateStatusmsg",
      
    ]),
  },
  beforeMount() {},
};
</script>
